import { usePathname } from "@opensea/navigation"
import { useAccountStates } from "@opensea/wallet"
import type { PropsWithChildren } from "react"
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from "@/constants/constants"
import { AccountBannedPage } from "./AccountBannedPage"

type Props = PropsWithChildren

export function AccountBannedGuard({ children }: Props) {
  const pathname = usePathname()
  const accountStates = useAccountStates()

  if ([PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL].includes(pathname)) {
    return children
  }

  if (accountStates.length === 0) {
    return children
  }

  const restrictedStates = ["STATE_100", "STATE_200", "STATE_300", "STATE_500"]
  if (!accountStates.some(state => restrictedStates.includes(state))) {
    return children
  }

  return <AccountBannedPage />
}
